import type { ReactNode } from 'react';
import { cn } from '@bliks-io/ui';

interface WizardStatCardProps {
  label: string;
  value: ReactNode;
  /** 14px lucide icon or an 8px status dot rendered before the label */
  icon?: ReactNode;
  sublabel?: string;
  tone?: 'default' | 'warning';
  className?: string;
  /** Overrides the 28px design number size (resolve screen uses 32px) */
  valueClassName?: string;
}

/**
 * Numeric summary card from the onboarding design (overview grid and the
 * manager-resolution Offen/Bereits-gelöst pair). Named apart from the shared
 * @bliks-io/ui StatCard, which is a different component.
 */
export function WizardStatCard({
  label,
  value,
  icon,
  sublabel,
  tone = 'default',
  className,
  valueClassName
}: WizardStatCardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border p-4',
        tone === 'warning' ? 'border-warning-solid bg-warning-solid/6' : 'border-line bg-white',
        className
      )}
    >
      <div className="flex items-center gap-1.75 text-[11.5px] font-semibold text-fg-secondary">
        {icon}
        {label}
      </div>
      <div
        className={cn(
          'mt-1.5 font-display text-[28px] font-extrabold text-foreground',
          valueClassName
        )}
      >
        {value}
      </div>
      {sublabel && <div className="text-2xs text-fg-subtle">{sublabel}</div>}
    </div>
  );
}
